var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBenefit1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.333,
    cy: 59.111,
    r: 12.444,
    fill: "#FFAF31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.526 3.11c-15.464 0-28 12.537-28 28v15.557l-3.972 7.942c-1.034 2.069.47 4.503 2.783 4.503h58.377c2.313 0 3.817-2.434 2.782-4.503l-3.97-7.94V31.11c0-15.464-12.536-28-28-28z",
    fill: "#FFCD58"
  })));
}
export default SvgBenefit1;